/**
 * MiniStats - Abbreviated stats grid for model cards (2 rows, 3 columns).
 */

import type { LLMModelOption } from '@/types';
import {
  getModelAttributes,
  ATTRIBUTE_FIXED_COLORS,
  formatCostDisplay,
} from '@/constants/llm/modelAttributes';

export function MiniStats({ model }: { model: LLMModelOption }) {
  const attrs = getModelAttributes(model);
  if (!attrs) return null;

  const stats = [
    { abbrev: 'SPD', display: String(attrs.speed) },
    { abbrev: 'AGI', display: String(attrs.agility) },
    { abbrev: 'INT', display: String(attrs.intelligence) },
    { abbrev: 'PWR', display: String(attrs.power) },
    { abbrev: 'ATK', display: formatCostDisplay(attrs.attack) },
    { abbrev: 'DEF', display: formatCostDisplay(attrs.defense) },
  ];

  return (
    <div className="grid grid-cols-3 gap-x-1 gap-y-0.5 mt-1">
      {stats.map(({ abbrev, display }) => (
        <span key={abbrev} className={`text-[8px] font-medium ${ATTRIBUTE_FIXED_COLORS[abbrev]}`}>
          {abbrev} {display}
        </span>
      ))}
    </div>
  );
}

export default MiniStats;
